import React,{useState,useEffect,}from 'react'
import Main from '../../cpn/Main'
import { Table,Space,Modal,message,Flex} from 'antd';
import { useDelNewsMutation, useNewsListQuery, useNewsStateMutation,} from '../../store/ReactWebSiteApi';
import NewsEdit from './NewsEdit';
import NewsTypeForm from '../newsType/NewsTypeForm';
import NewsCheck from './NewsCheck';
import NewsTypeCheck from '../newsType/NewsTypeCheck';
import NewsAdd from './NewsAdd';
function NewsList() {
    //删除新闻----------------------------------------------------------------------------------------------------------------删除新闻//
    const {confirm} = Modal; 
    const [delBusiness] = useDelNewsMutation()
    //上下架新闻----------------------------------------------------------------------------------------------------------------上下架新闻//
    const [newsState] = useNewsStateMutation()
    //新闻列表----------------------------------------------------------------------------------------------------------------新闻列表//
    const [query,setQuery] = useState({en_e_id:localStorage.getItem('e_id'),en_type_id:""})    
    const {data, isSuccess} = useNewsListQuery(query);    
    const [list, setList] = useState();    
    useEffect(() => {
        if (isSuccess) {
            // //console.log(data);
            if(data.Status==='success'){                
                const newArr = data.Result.map(item => {
                    const {en_id:key,en_image,en_name,en_num,en_content,en_uname,en_ctime,en_type_id,en_state,en_type_name} = item;
                    return item = {key,en_image,en_name,en_num,en_content,en_uname,en_ctime,en_type_id,en_state,en_type_name}
                })                
                const sortArr = newArr.sort( (a, b) => {      
                    let aTimeString = a.en_ctime;
                    let bTimeString = b.en_ctime;
                    let aTime = new Date(aTimeString).getTime();
                    let bTime = new Date(bTimeString).getTime();
                    return bTime - aTime;     
                    },)
                setList(sortArr)
            }else{
                setList('')
            }
            
        }
    }, [data, isSuccess])
    
    
    
    const columns = [
        {
            key: 'id',
            title: '编号',
            dataIndex: 'key'
        },
        {
            key: 'en_type_name',
            title: '类型',
            dataIndex:'en_type_name',
            render:(_,record) => {
                return  <NewsTypeCheck
                            text={record.en_type_name}
                            ent_id={record.en_type_id}
                        />
            }            
        },
        {
            key: 'room',
            title: '标题',
            dataIndex: 'en_name',
            render:(_,record) => {
                return  <NewsCheck 
                            text={record.en_name}
                            en_id={record.key}
                            en_image={record.en_image}
                        />
            }
        },
        {
            key: 'min',
            title: '阅读次数',
            dataIndex: 'en_num',
        },
        {
            key: 'num',
            title: '状态',            
            dataIndex: 'en_state',
            render:(text) => {
                if(text==='1'){
                    return<>待上架</>
                }else{
                    return<>已上架</>
                }
            }
        },
        {
            key: 'time',
            title: '创建/修改时间',
            render: (_,record) => {
                return <>
                    <div>新建时间：{record.en_ctime + record.en_uname}</div>
                    <div>修改时间：</div>
                </>
            }
        },
        {
            key: 'action',
            title: '操作',
            render: (_, record) => {
                return <>
                    <Space>                       
                        <NewsEdit 
                            en_id={record.key}
                        />
                        <a onClick={() => {
                            confirm({
                                title: '确定删除吗?',
                                content: '删除后不能恢复',
                                okText: '确认',
                                okType: 'danger',
                                cancelText: '取消',
                                onOk() {
                                    delBusiness({en_id:record.key}).then((res) => {
                                        if (res.data.Status === 'success') {

                                            message.info('删除成功！');
                                        }
                                        if (res.data.Status === "fail") {
                                            message.error('删除失败！'+res.data.Message)
                                        }
                                    })
                                },
                                onCancel() {
                                console.log('Cancel');
                                },
                            });
                        }}>删除</a>
                        {(record.en_state==='1') ? <>
                                <a onClick={() => {
                                    newsState({en_id:record.key,en_state:'1'}).then((res) => {
                                        if(res.data.Status==='success'){
                                            message.info('上架成功！')
                                        }else{
                                            message.error('上架失败！' + res.data.Message)
                                        }
                                    })
                                }}>上架</a>
                            </>:<>
                                <a onClick={() => {
                                    newsState({en_id:record.key,en_state:'2'}).then((res) => {
                                        if(res.data.Status==='success'){
                                            message.info('下架成功！')
                                        }else{
                                            message.error('下架失败！' + res.data.Message)
                                        }
                                    })
                                }}>下架</a>
                            </>}
                    </Space>
                </>
            }
        },
    ]

      
    return (
        <Main t1='推广'  t2='新闻' >
            <Flex justify='space-between'>
                <NewsTypeForm
                    wrapperCol={{span:15}}
                    style={{marginBottom:'0',width:"300px"}}
                    onChange={(e) => {setQuery(prevState=>({...prevState,en_type_id:e}))}}
                    onClear={() => {setQuery(prevState=>({...prevState,en_type_id:''}))}}
                />
                <NewsAdd />
            </Flex>
            <Table columns={columns} style={{marginTop:'20px'}} dataSource={list}></Table>
        </Main>
    )
}

export default NewsList